import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import PublisherPrefixRangeList from "./PublisherPrefixRangeList";
import PublisherPrefixRangeForm from "./PublisherPrefixRangeForm";
import { RouteGuard } from "../../guards/RouteGuard";
import { RoleEnum } from "../../types/RoleEnum";
function PublisherPrefixRanges() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER] },
                React.createElement(PublisherPrefixRangeList, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/create"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER] },
                React.createElement(PublisherPrefixRangeForm, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/edit/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER] },
                React.createElement(PublisherPrefixRangeForm, null))); } })));
}
export default PublisherPrefixRanges;
